"use client" // Error components must be Client Components

import { useErrorCapture } from "@/lib/hooks/useErrorCapture"

export default function NFTModalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useErrorCapture(error, "nft-modal")

  return (
    <div>
      <h2>Something went wrong!</h2>
      <button
        onClick={
          // Attempt to recover by trying to re-render the segment
          () => reset()
        }
      >
        Try again
      </button>
    </div>
  )
}
